const formStylesSchema = (data) => (
  data.reduce((acc, config) => {
    if (
      config.path === 'theme_design/colors/color_primary' ||
    config.path === 'theme_design/colors/color_secondry' ||
    config.path === 'theme_design/colors/color_additional' ||
    config.path === 'theme_design/colors/color_primary_text_color'
    ) {
      return {...acc, colors: {...acc.colors, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/defined_fonts/google_fonts_string' ||
    config.path === 'theme_design/defined_fonts/font_stacks_string' ||
    config.path === 'theme_design/font/body_font_size' ||
    config.path === 'theme_design/font/body_font_family' ||
    config.path === 'theme_design/font_fallback/body_font_stack' ||
    config.path === 'theme_design/font/heading1_font_family' ||
    config.path === 'theme_design/font/heading1_font_color' ||
    config.path === 'theme_design/font/heading1_font_size' ||
    config.path === 'theme_design/font/heading1_font_weight' ||
    config.path === 'theme_design/font/heading1_text_transform' ||
    config.path === 'theme_design/font/heading1_line_height' ||
    config.path === 'theme_design/font/heading2_font_family' ||
    config.path === 'theme_design/font/heading2_font_color' ||
    config.path === 'theme_design/font/heading2_font_size' ||
    config.path === 'theme_design/font/heading2_font_weight' ||
    config.path === 'theme_design/font/heading2_text_transform' ||
    config.path === 'theme_design/font/heading2_line_height' ||
    config.path === 'theme_design/font/heading3_font_family' ||
    config.path === 'theme_design/font/heading3_font_color' ||
    config.path === 'theme_design/font/heading3_font_size' ||
    config.path === 'theme_design/font/heading3_font_weight' ||
    config.path === 'theme_design/font/heading3_text_transform' ||
    config.path === 'theme_design/font/heading3_line_height' ||
    config.path === 'theme_design/font/heading4_font_family' ||
    config.path === 'theme_design/font/heading4_font_color' ||
    config.path === 'theme_design/font/heading4_font_size' ||
    config.path === 'theme_design/font/heading4_font_weight' ||
    config.path === 'theme_design/font/heading4_text_transform' ||
    config.path === 'theme_design/font/heading4_line_height' ||
    config.path === 'theme_design/font/heading5_font_family' ||
    config.path === 'theme_design/font/heading5_font_color' ||
    config.path === 'theme_design/font/heading5_font_size' ||
    config.path === 'theme_design/font/heading5_font_weight' ||
    config.path === 'theme_design/font/heading5_text_transform' ||
    config.path === 'theme_design/font/heading5_line_height' ||
    config.path === 'theme_design/font/heading6_font_family' ||
    config.path === 'theme_design/font/heading6_font_color' ||
    config.path === 'theme_design/font/heading6_font_size' ||
    config.path === 'theme_design/font/heading6_font_weight' ||
    config.path === 'theme_design/font/heading6_text_transform' ||
    config.path === 'theme_design/font/heading6_line_height' ||
    config.path === 'theme_design/font/paragraph_font_family' ||
    config.path === 'theme_design/font/paragraph_font_color' ||
    config.path === 'theme_design/font/paragraph_font_size' ||
    config.path === 'theme_design/font/paragraph_line_height' ||
    config.path === 'theme_design/font/list_style_type'
    ) {
      return {...acc, typography: {...acc.typography, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/colors/link_color' ||
    config.path === 'theme_design/colors/link_hover_color' ||
    config.path === 'theme_design/colors/link_text_decoration' ||
    config.path === 'theme_design/colors/link_text_decoration_hover' ||
    config.path === 'theme_design/colors/link_font_weight'
    ) {
      return {...acc, links: {...acc.links, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/colors/button_bg_color' ||
    config.path === 'theme_design/colors/button_color' ||
    config.path === 'theme_design/colors/button_hover_bg_color' ||
    config.path === 'theme_design/colors/button_hover_color' ||
    config.path === 'theme_design/colors/button_font_size' ||
    config.path === 'theme_design/colors/button_font_family' ||
    config.path === 'theme_design/colors/button_text_transform' ||
    config.path === 'theme_design/colors/button_font_weight' ||
    config.path === 'theme_design/colors/button_font_style' ||
    config.path === 'theme_design/colors/button_border_radius' ||
    config.path === 'theme_design/colors/button_border' ||
    config.path === 'theme_design/colors/button_border_hover'
    ) {
      return {...acc, buttons: {...acc.buttons, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/colors/label_new_bg_color' ||
    config.path === 'theme_design/colors/label_new_color' ||
    config.path === 'theme_design/colors/label_sale_bg_color' ||
    config.path === 'theme_design/colors/label_sale_color'
    ) {
      return {...acc, labels: {...acc.labels, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/header/header_bg_color' ||
    config.path === 'theme_design/header/top_border_color' ||
    config.path === 'theme_design/header_primary/text_font_size' ||
    config.path === 'theme_design/header_primary/text_color' ||
    config.path === 'theme_design/header_primary/text_link_color' ||
    config.path === 'theme_design/header_primary/text_link_hover_color' ||
    config.path === 'theme_design/header_primary/button_color' ||
    config.path === 'theme_design/header_primary/button_hover_color' ||
    config.path === 'theme_design/header_primary/button_background' ||
    config.path === 'theme_design/header_primary/button_hover_background'
    ) {
      return {...acc, header: {...acc.header, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/m_header/tab_item_bg_color' ||
    config.path === 'theme_design/m_header/tab_item_color' ||
    config.path === 'theme_design/m_header/counter_bg_color' ||
    config.path === 'theme_design/m_header/counter_bg_active_color' ||
    config.path === 'theme_design/m_header/sub_menu_bg' ||
    config.path === 'theme_design/m_header/sub_menu_color' ||
    config.path === 'theme_design/m_header/sub_menu_font_family' ||
    config.path === 'theme_design/m_header/sub_menu_text_transform' ||
    config.path === 'theme_design/m_header/sub_menu_font_size' ||
    config.path === 'theme_design/m_header/sub_menu_font_weight'
    ) {
      return {...acc, mobile: {...acc.mobile, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/nav/outer_menu_bg_color' ||
    config.path === 'theme_design/nav/color' ||
    config.path === 'theme_design/nav/hover_bg_color' ||
    config.path === 'theme_design/nav/hover_color' ||
    config.path === 'theme_design/nav/font_family' ||
    config.path === 'theme_design/nav/text_transform' ||
    config.path === 'theme_design/nav/font_size' ||
    config.path === 'theme_design/nav/font_weight' ||
    config.path === 'theme_design/nav/text_decoration' ||
    config.path === 'theme_design/nav/text_decoration_hover' ||
    config.path === 'theme_design/nav/letter_spacing' ||
    config.path === 'theme_design/nav/is_menu_item_underline_effect' ||
    config.path === 'theme_design/nav/underline_height' ||
    config.path === 'theme_design/nav/underline_color' ||
    config.path === 'theme_design/nav/dropdown_bg_color' ||
    config.path === 'theme_design/nav/dropdown_item_hover_bg_color' ||
    config.path === 'theme_design/nav/dropdown_link_color' ||
    config.path === 'theme_design/nav/dropdown_link_hover_color' ||
    config.path === 'theme_design/nav/dropdown_font_family' ||
    config.path === 'theme_design/nav/dropdown_text_transform' ||
    config.path === 'theme_design/nav/dropdown_font_size' ||
    config.path === 'theme_design/nav/dropdown_font_weight' ||
    config.path === 'theme_design/nav/dropdown_text_decoration' ||
    config.path === 'theme_design/nav/dropdown_text_decoration_hover' ||
    config.path === 'theme_design/nav/dropdown_item_is_border_bottom' ||
    config.path === 'theme_design/nav/dropdown_item_border_bottom'
    ) {
      return {...acc, menu: {...acc.menu, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/footer/bg_color' ||
    config.path === 'theme_design/footer/color' ||
    config.path === 'theme_design/footer/link_color' ||
    config.path === 'theme_design/footer/link_hover_color' ||
    config.path === 'theme_design/footer/border_top' ||
    config.path === 'theme_design/footer/button_bg_color' ||
    config.path === 'theme_design/footer/button_color' ||
    config.path === 'theme_design/footer/button_hover_bg_color' ||
    config.path === 'theme_design/footer/button_hover_color' ||
    config.path === 'theme_design/footer_bottom/color' ||
    config.path === 'theme_design/footer_bottom/link_color' ||
    config.path === 'theme_design/footer_bottom/link_hover_color' ||
    config.path === 'theme_design/footer_bottom/bg_color' ||
    config.path === 'theme_design/footer_tagline/bg_color' ||
    config.path === 'theme_design/footer_tagline/color' ||
    config.path === 'theme_design/footer_tagline/font_size' ||
    config.path === 'theme_design/footer_tagline/font_weight' ||
    config.path.includes('premium_plus_footer')
    ) {
      return {...acc, footer: {...acc.footer, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/colors/price_color' ||
    config.path === 'theme_design/colors/price_font_size' ||
    config.path === 'theme_design/colors/price_font_weight' ||
    config.path === 'theme_design/colors/rating_active_color' ||
    config.path === 'theme_design/colors/product_name_color' ||
    config.path === 'theme_design/colors/product_name_font_size' ||
    config.path === 'theme_design/colors/product_name_font_weight' ||
    config.path === 'theme_design/colors/product_name_text_transform' ||
    config.path === 'theme_design/colors/product_name_text_align' ||
    config.path === 'theme_design/category/category_promo_font_family' ||
    config.path === 'theme_design/category/category_promo_font_size' ||
    config.path === 'theme_design/category/category_promo_font_weight' ||
    config.path === 'theme_design/category/category_promo_line_height' ||
    config.path === 'theme_design/category/category_promo_padding' ||
    config.path === 'theme_design/category/category_promo_bg_color' ||
    config.path === 'theme_design/category/category_promo_color'
    ) {
      return {...acc, category_page: {...acc.category_page, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/product_page/product_promo_font_family' ||
    config.path === 'theme_design/product_page/product_promo_font_size' ||
    config.path === 'theme_design/product_page/product_promo_font_weight' ||
    config.path === 'theme_design/product_page/product_promo_line_height' ||
    config.path === 'theme_design/product_page/product_promo_padding' ||
    config.path === 'theme_design/product_page/product_promo_bg_color' ||
    config.path === 'theme_design/product_page/product_promo_color' ||
    config.path === 'theme_design/product_page/product_tabs_bg_color' ||
    config.path === 'theme_design/product_page/product_tabs_color' ||
    config.path === 'theme_design/product_page/product_tabs_bg_color_active' ||
    config.path === 'theme_design/product_page/product_tabs_color_active'
    ) {
      return {...acc, product_page: {...acc.product_page, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/main/login_promo_bg_color' ||
    config.path === 'theme_design/main/login_promo_color' ||
    config.path === 'theme_design/main/login_promo_title_font_size' ||
    config.path === 'theme_design/main/login_promo_title_font_weight' ||
    config.path === 'theme_design/main/login_promo_font_family' ||
    config.path === 'theme_design/main/login_promo_desc_font_size' ||
    config.path === 'theme_design/main/login_promo_text_transform'
    ) {
      return {...acc, cart_page: {...acc.cart_page, [config.path]: config.value}};
    }

    if (
      config.path === 'theme_design/cta/cta_mask_bg' ||
    config.path === 'theme_design/cta/cta_mask_title_color' ||
    config.path === 'theme_design/cta/cta_mask_link_color' ||
    config.path === 'theme_design/cta/cta_mask_link_color_hover' ||
    config.path === 'theme_design/cta/cta_mask_button_bg' ||
    config.path === 'theme_design/cta/cta_mask_button_color' ||
    config.path === 'theme_design/cta/cta_mask_button_bg_hover' ||
    config.path === 'theme_design/cta/cta_mask_button_color_hover' ||
    config.path === 'theme_design/cta/button_border' ||
    config.path === 'theme_design/cta/button_border_hover' ||
    config.path === 'theme_design/cta/cta_vertical_title_color' ||
    config.path === 'theme_design/cta/cta_horizontal_top_title_color' ||
    config.path === 'theme_design/cta/cta_horizontal_bottom_title_color' ||
    config.path === 'theme_design/cta/cta_title_font_weight'
    ) {
      return {...acc, homepage_cta: {...acc.homepage_cta, [config.path]: config.value}};
    }

    if (
      config.path.includes('theme_design/premium_plus_homepage/premium_plus_cta')
    ) {
      return {...acc, premium_plus_cta: {...acc.premium_plus_cta, [config.path]: config.value}};
    }

    if (
      config.path.includes('theme_design/premium_plus_homepage/additional_header')
    ) {
      return {...acc, additional_header: {...acc.additional_header, [config.path]: config.value}};
    }

    if (
      config.path.includes('theme_design/premium_plus_homepage/testimonials')
    ) {
      return {...acc, premium_plus_testimonials: {...acc.premium_plus_testimonials, [config.path]: config.value}};
    }

    if (
      config.path.includes('theme_design/premium_plus_homepage/blog')
    ) {
      return {...acc, premium_plus_blog: {...acc.premium_plus_blog, [config.path]: config.value}};
    }

    if (
      config.path.includes('theme_design/premium_plus_homepage/instagram')
    ) {
      return {...acc, premium_plus_instagram: {...acc.premium_plus_instagram, [config.path]: config.value}};
    }

    return acc;
  }, {
    colors: [],
    typography: [],
    links: [],
    buttons: [],
    labels: [],
    header: [],
    mobile: [],
    menu: [],
    footer: [],
    category_page: [],
    product_page: [],
    cart_page: [],
    homepage_cta: [],
    premium_plus_cta: [],
    additional_header: [],
    premium_plus_testimonials: [],
    premium_plus_blog: [],
    premium_plus_instagram: []
  })
);

export default formStylesSchema;
